"use client";
import { ExtendedUser } from "@/server/actions/fetch-or-create-user";
import { createContext } from "react";
import { Project } from "@prisma/client";

export const UserContext = createContext<{
  user: ExtendedUser | null;
  project: Project | null;
}>(undefined!);

export function UserProvider({
  children,
  context,
}: {
  children: React.ReactNode;
  context: {
    user: ExtendedUser | null;
    project: Project | null;
  };
}) {
  return (
    <UserContext.Provider value={context}>{children}</UserContext.Provider>
  );
}
